<app-modal
  [isActive]="showModal"
  [showAcceptFooter]="!remarkSaved"
  [acceptFooterDisabled]="acceptDisabled"
  [showCloseFooter]="!acceptDisabled"
  [showClose]="false"
  (acceptState)="FinishByUser()"
  (modalState)="exit()"
>
  <p class="modal-card-title" modal-title>
    <em class="mdi mdi-message-alert has-text-warning mdi-18px" aria-hidden="true"></em>
    {{ 'shared.unsaved' | translate }}
  </p>

  <div modal-content>
    <app-tiny-alert [isProcessed]="''" message="shared.messageValideForm" *ngIf="validForm">
    </app-tiny-alert>
    <div [formGroup]="formCloseReason">
      <div>
        <p>
          <em class="has-text-warning mdi-18px" aria-hidden="true"></em>
          {{ 'shared.messageClosePnrModal' | translate }}
        </p>
        <select formControlName="reason" (change)="changeOption($event)">
          <option *ngFor="let item of listStatusTypeMessage" [value]="item.code">
            {{ item.name | translate }}
          </option>
        </select>
      </div>

      <br />

      <div *ngIf="isaFailureAgent">
        <p>
          {{ 'shared.messageDetailClosePnr' | translate }}
        </p>
        <textarea formControlName="detail"> </textarea>
      </div>

      <div *ngIf="readyToRemark" class="remark-section">
        <div
          *ngIf="!(remarkSavedOnProccess$ | async)?.closePNR"
          class="alert alert-warning"
          role="alert"
        >
          {{ 'remarks.save-before-leave' | translate }}
        </div>

        <div
          *ngIf="(remarkSavedOnProccess$ | async)?.closePNR"
          class="alert alert-success"
          role="alert"
        >
          {{ 'remarks.you-can-leave-now' | translate }}
        </div>

        <div *ngIf="!(remarkSavedOnProccess$ | async)?.closePNR" class="separator"></div>

        <div *ngIf="!(remarkSavedOnProccess$ | async)?.closePNR" class="remark-component">
          <app-remarks [isMarginTop]="false" [savedFromProccess]="currentOptionType"></app-remarks>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<nav
  class="breadcrumb is-medium has-background-white has-arrow-separator is-marginless"
  aria-label="breadcrumbs"
  [class.has-background-warning]="exceptionMode"
  [class.has-background-red]="connectionTimeDifference && !exceptionMode"
  [class.has-text-white]="exceptionMode || connectionTimeDifference"
>
  <div class="container is-fluid breadcrumb-container">
    <div class="columns is-vcentered">
      <div class="column is-5 pb-0">
        <ul>
          <li
            *ngFor="let breadcrumb of breadcrumbs"
            [class.is-active]="breadcrumb.isActive"
            [class.has-text-white]="exceptionMode || connectionTimeDifference"
          >
            <a
              [class.has-text-white]="exceptionMode || connectionTimeDifference"
              routerLinkActive="router-link-active"
              class="weight-medium"
            >
              <div *ngIf="breadcrumb.route === 'itinerary'; else translate">
                {{ breadcrumb.name | uppercase }}
              </div>
              <ng-template #translate>
                <span>
                  {{ 'breadcrumb.' + breadcrumb.name | translate | firstcase }}
                </span>
              </ng-template>
            </a>
          </li>
        </ul>
      </div>
      <div class="column pb-0" *ngIf="connectionTimeDifference && !exceptionMode">
        <em class="mdi mdi-alert mdi-18px" aria-hidden="true"></em> &nbsp;
        <span class="is-size-6">{{ pnrInfo.itinerary.connectionTime.message }}</span>
      </div>
      <div class="column pb-0">
        <div class="is-pulled-right">
          <div class="switch-container">
            <app-input-switch
              id="mode"
              [value]="exceptionMode"
              [disabled]="loadingActions || !isItinerary()"
              label="{{ 'exception-mode.switch' | translate }}"
              (changeValue)="toogleExceptionMode.emit($event)"
            ></app-input-switch>

            <span *ngIf="!isItinerary()" class="material-icons lock-icon">lock</span>
          </div>
        </div>
      </div>

      <div class="column pb-0 end-action">
        <app-input-submit
          [isDanger]="true"
          inputText="{{ 'shared.closePnr' | translate }}"
          type="submit"
          (clickButton)="OpenModal()"
        ></app-input-submit>
      </div>
    </div>
  </div>
</nav>
